import { useCallback } from 'react';
import { useReduxForm } from '@rainbow-modules/hooks';
import { CheckboxGroupProps } from 'react-rainbow-components/components/CheckboxGroup';
import CheckBoxGroupFilter, { CheckBoxGroupFilterLabel } from 'components/CheckBoxGroupFilter';

interface Params extends Omit<CheckboxGroupProps, 'value' | 'onChange'> {
    value?: string[] | null;
    onChange?: (values: string[] | null) => void;
}

const statuses = [
    { name: 'blocked', label: 'Blocked' },
    { name: 'busy', label: 'Busy' },
    { name: 'canceled', label: 'Canceled' },
    { name: 'completed', label: 'Completed' },
    { name: 'failed', label: 'Failed' },
    { name: 'initiated', label: 'Initiated' },
    { name: 'in-progress', label: 'In Progress' },
    { name: 'no-answer', label: 'No Answer' },
    { name: 'queued', label: 'Queued' },
    { name: 'ringing', label: 'Ringing' },
];

const CallStatusFilter = (props: Params) => {
    const {
        value: valueInProps,
        onChange = () => {},
        ...rest
    } = useReduxForm(props);

    const options = statuses.map(
        (status) => ({
            value: status.name,
            label: <CheckBoxGroupFilterLabel>{status.label}</CheckBoxGroupFilterLabel>,
        }),
    );

    const value = valueInProps ?? [];

    const handleOnChange = useCallback(
        (values: string[]) => {
            if (!values?.length) return onChange(null);
            return onChange(values);
        },
        [onChange],
    );

    return (
        <CheckBoxGroupFilter
            {...rest}
            hideLabel
            options={options}
            value={value}
            onChange={handleOnChange}
        />
    );
};

export default CallStatusFilter;
